import React from "react";
import ReactDOM from "react-dom";
import { Dropdown } from "react-bootstrap";
import "./index.css";

// PortalMenu component to render dropdown menu in document.body
const PortalMenu = React.forwardRef(({ children, style, role, className, show, close, align, onKeyDown, ...props }, ref) => {
  return ReactDOM.createPortal(
    <div
      {...props}
      ref={ref}
      role={role}
      className={className}
      style={{ ...style, zIndex: 1050 }}
    >
      {children}
    </div>,
    document.body
  );
});

export default function ActionDropDown({
  icon,
  actions,
  id,
  as,
  show,
  onToggle,
  align = "start",
  ...props
}) {
  return (
    <Dropdown
      align={align}
      as={as}
      show={show}
      onToggle={onToggle}
      className="position-relative common-action-btn"
      {...props}
    >
      <Dropdown.Toggle
        variant="none"
        className="outline-none border-0 p-0 d-flex align-items-center justify-content-center drop-btn"
        id={id}
      >
        {icon}
      </Dropdown.Toggle>

      <Dropdown.Menu
        as={PortalMenu}
        className="border p-2 rounded-2 action-drop-menu shadow-sm bg-white"
      >
        {actions?.map((action, index) => {
          return (
            <Dropdown.Item
              as={"button"}
              key={index}
              onClick={action.handler}
              className="text-capitalize rounded-2 fw-normal action-drop-item"
            >
              {action.title}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
}
